"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationAEValidator = void 0;
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
class ConfigurationAEValidator {
    /**
     * Validates if an array of AEs is valid as pair.
     * A single object can still be a valid pair.
     */
    static aesAreValidPair(configuration, keyPrefix) {
        const kette = configuration.getKetteClone();
        if (!keyPrefix)
            keyPrefix = '';
        switch (kette === null || kette === void 0 ? void 0 : kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
                return echain_shared_validation_1.Validation.success();
            case undefined:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.eskin:
            case echain_shared_articles_1.KetteSerieType.rolEchain:
            case echain_shared_articles_1.KetteSerieType.rxRohr: {
                const aes = configuration.getAEsClone().toArray();
                const hasNoAe = configuration.hasNoAE();
                if (hasNoAe) {
                    if (aes.length === 0) {
                        return echain_shared_validation_1.Validation.empty();
                    }
                    return echain_shared_validation_1.Validation.fail(keyPrefix + echain_shared_articles_oo_1.AEValidatorKeys.aesDespiteHasNoAE);
                }
                if (aes.length === 0) {
                    return echain_shared_validation_1.Validation.fail(keyPrefix + echain_shared_articles_oo_1.AEValidatorKeys.notSet);
                }
                if (aes.length === 1) {
                    return echain_shared_validation_1.Validation.fail(echain_shared_articles_oo_1.AEValidator.isAEKomplettSatz(aes[0], keyPrefix));
                }
                if (aes.length === 2) {
                    return echain_shared_validation_1.Validation.fail(echain_shared_articles_oo_1.AEValidator.validApplicationFlags(aes, keyPrefix));
                }
                return echain_shared_validation_1.Validation.fail(keyPrefix + echain_shared_articles_oo_1.AEValidatorKeys.moreThanTwoPresent);
            }
        }
    }
}
exports.ConfigurationAEValidator = ConfigurationAEValidator;
//# sourceMappingURL=ConfigurationAEValidator.js.map